import { createFileRoute, Link } from '@tanstack/react-router'
import { Button } from '@viastud/ui/button'
import { grade as grades, GradeEnum } from '@viastud/utils'

import { useAuthStore } from '@/store/auth.store.ts'

export const Route = createFileRoute('/_student/_layout/ressources/')({
  component: Ressources,
})

function RessourcesComponent() {
  const auth = useAuthStore()
  const navigate = Route.useNavigate()

  void navigate({
    to: '/ressources/$grade',
    params: { grade: auth.user?.grade?.toLowerCase() ?? '' },
  })
  const userGrade = auth.user?.grade

  return (
    <div className="flex w-4/5 flex-col items-stretch gap-4 pt-4">
      <p className="text-2xl font-extrabold text-gray-950">Toutes les ressources</p>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(240px,1fr))] gap-4">
        {grades.map((grade) => (
          <Link
            key={grade}
            to="/ressources/$grade"
            params={{ grade: grade.toLowerCase() }}
            disabled={userGrade !== grade}
            className="flex"
          >
            <Button
              disabled={userGrade !== grade}
              variant="none"
              className={`flex h-56 w-full grow items-center justify-center whitespace-normal rounded-2xl border text-xl ${
                userGrade === grade
                  ? 'border-blue-200 bg-blue-50 text-gray-950 hover:border-blue-300 hover:bg-blue-100'
                  : 'border-gray-300 text-gray-700'
              }`}
            >
              {GradeEnum[grade]}
            </Button>
          </Link>
        ))}
      </div>
    </div>
  )
}

function Ressources() {
  return <RessourcesComponent />
}
